// KAN-9620: this codebase builds desktop web only; native iOS lives in the
// separate Expo workspace (epic KAN-9592). Helpers kept so callers compile.
export function isNativePlatform(): boolean {
  return false;
}

export function getWebOrigin(): string {
  return window.location.origin;
}
